import * as React from 'react';
import ModuleGameboyStore from '../_stores/ModuleGameboyStore';

export type Props = {
	moduleId?: string
}

export default class ModuleGameboySettings extends React.Component<Props> {
	render = () => <></>
}